import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SocialClub from "../views/SocialClub";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/social',
    name: 'Social',
    component: SocialClub
  }
]

const router = new VueRouter({
  mode: "history",
  base: '/',
  routes
})

export default router
